// Only used for testing the solution without connection to backend
export const getMockProviderInfo = () => {
  // Using local values
  return {
    isGoogleEnabled: true,
    isAppleEnabled: true,
    isFacebookEnabled: true,
  };
};

export const getLoginMockl10n = () => {
  return {
    'apple.login.error.noAccount': 'No account exist with that apple id',
    'generic.error.contactSupport': 'Contact customer support',
    'google.login.error.noAccount': 'No account exist with that google id',
    'login.username': 'Email',
    'login.resetPassword': 'Have you forgotten your password? Click here.',
    'login.password': 'Password',
    'google.loginWith': 'Sign in with Google',
    'apple.loginWith': 'Sign in with Apple',
    'facebook.loginWith': 'Sign in with Facebook',
    'login.orWith': 'or with',
    'login.noAccount.signup.text': "Don't have an account?",
    'login.noAccount.signup.link': 'Sign up',
    'login.login': 'Log in',
    'generic.error.message': 'Something went wrong, please try again later.',
  };
};

export const getSignupMockl10n = () => {
  return {
    'signUpForm.title': 'Create Account',
    'createAccount.stepTitle': 'Step',
    'signUpForm.stepDetails': 'Account Information',
    'signUp.createAccount': 'Next',
    'account.email': 'E-mail',
    'login.password': 'Password',
    'purchase.userAgrementTrail': 'user agreement trail',
    'purchase.userAgrement1': "I agree to Storytel's",
    'purchase.userAgrement2': 'terms and conditions',
    'purchase.privacyPolicy.text':
      'If you want to know more about how Storytel will process your personal data, please read our',
    'purchase.privacyPolicyTrail': 'privacy policy trail',
    'purchase.privacyPolicy': 'Privacy Policy',
    'generic.error.message': 'Something went wrong, please try again later.',
    'account.newsletter':
      '<b>Yes please</b>, I’m happy to receive emails and in app notifications regarding personal recommendations, events, offers and the latest book news from Storytel and Storytel’s business partners.',
    'purchase.privacyPolicy_autocheck.text':
      'You can read more how Storytel will process your personal data in our',
    'purchase.privacyPolicyTrail_autocheck': '',
    'purchase.userAgrement1_autocheck': 'By creating an account, you agree to our',
    'purchase.userAgrementTrail_autocheck': '',
  };
};

export const getMockedTermsData = () => {
  return {
    termsAndConditions: 'www.google.com',
    privacyPolicy: 'www.catapi.com',
  };
};
